export default "__VITE_ASSET__6eb1f0d5__"